package com.havn.app.features.auth.data

actual object HavnAppleSignIn {
    actual val isNativeAvailable: Boolean = false

    actual suspend fun requestCredential(): HavnAppleSignInCredential {
        error("Native Apple Sign In is only available on iOS.")
    }
}
